export const isValidSwissPhoneNumber = (phoneNumber: string): boolean => {
  // Swiss phone numbers can be in formats:
  // +41 XX XXX XX XX
  // 0XX XXX XX XX
  const swissPhoneRegex = /^(?:(?:\+|00)41|0)(?:(?:[\s]?[0-9]){9})$/;
  return swissPhoneRegex.test(phoneNumber.replace(/\s/g, ''));
};

export const formatSwissPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Format the number
  if (cleaned.startsWith('0')) {
    // Format: 0XX XXX XX XX
    return cleaned.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  } else if (cleaned.startsWith('41')) {
    // Format: +41 XX XXX XX XX
    return (
      '+' +
      cleaned.replace(/(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')
    );
  }

  return phoneNumber;
};
